<template>
  <v-dialog persistent :value="dialogShow" :max-width="maxWidth" content-class="elevation-0 bonus-dialog-scroll">
    <v-card class="dialog-card" style="position: relative;">
      <!-- Nav arrows - absolutely positioned at card vertical center -->
      <v-btn v-if="prevAction" icon class="dialog-nav-left" :disabled="!hasPrev" @click="prevAction">
        <v-icon large>mdi-chevron-left</v-icon>
      </v-btn>
      <v-btn v-if="nextAction" icon class="dialog-nav-right" :disabled="!hasNext" @click="nextAction">
        <v-icon large>mdi-chevron-right</v-icon>
      </v-btn>
      <!-- Close button - absolutely positioned at top right -->
      <v-icon :class="['dialog-close-icon', this.header_title == 'register' ? 'register' : this.header_title == 'login' ? 'login' : '']" @click="closeAction" v-if="closeAction != null">
        mdi-close
      </v-icon>

      <!-- Single scrollable area: title + image + slot content all scroll together -->
      <div class="dialog-scroll-area" v-if="dialogShow">
        <v-row justify="space-between" no-gutters :class="$vuetify.breakpoint.mdAndDown ? 'dialog-header pt-1' : 'dialog-header pt-1 px-11'">
          <v-col cols="12" class="px-6 pt-8">
            <label v-if="!isAuth && !isRegSuccess" class="dialog-title font-weight-bold ma-0 text-capitalize d-block full-width">
              {{ title }}
            </label>
            <img v-if="isRegSuccess" src="/static/svg/logo.svg" alt width="133" height="22" style="float:left;" />
          </v-col>
          <v-col cols="12" class="pt-2" v-if="subtitle">
            <label class="full-width dialog-subtitle">{{ subtitle }}</label>
          </v-col>
          <v-col>
            <v-img v-if="dialogImage" :src="dialogImage" alt="Dialog Image" max-height="250" contain />
          </v-col>
        </v-row>
        <div :class="customClass">
          <slot></slot>
        </div>
      </div>
    </v-card>
    <v-col no-gutters class="d-block" v-if="dialogShow">
      <slot name="footer"></slot>
    </v-col>
  </v-dialog>
</template>

<script>
export default {
  name: 'appDialog',
  props: {
    header_title: {
      type: String,
      required: false
    },
    isAuth: {
      type: Boolean,
      default: false,
      required: false
    },
    showDivider: {
      type: Boolean,
      default: true
    },
    closeAction: {
      required: false,
      default: null
    },
    dialogImage: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    maxWidth: {
      type: Number,
      required: false,
      default: 400
    },
    minHeight: {
      type: Number,
      required: false,
      default: 500
    },
    dialogShow: {
      type: Boolean,
      required: true,
      default: false
    },
    customClass: {
      type: String,
      required: false,
      default: 'pa-0'
    },
    openRegisterDialog: {
      type: Function,
      default: () => ({})
    },
    openLoginDialog: {
      type: Function,
      default: () => ({})
    },
    isRegSuccess: {
      type: Boolean,
      default: false,
      required: false
    },
    subtitle: {
      type: String,
      required: false,
      default: ''
    },
    hasPrev: {
      type: Boolean,
      default: false
    },
    hasNext: {
      type: Boolean,
      default: false
    },
    prevAction: {
      type: Function,
      default: null
    },
    nextAction: {
      type: Function,
      default: null
    },
  },
}
</script>

<style>
.v-dialog {
  overflow-y: hidden !important;
}
.v-dialog:not(.v-dialog--fullscreen) {
  max-height: 95%;
}
.bonus-dialog-scroll {
  overflow-y: hidden !important;
  overflow-x: hidden !important;
  max-height: 90vh;
}
.v-dialog__content {
  overflow-y: hidden !important;
}
</style>

<style lang="scss" scoped>
.dialog-logo {
  width: 133px;
  height: 22px;
  padding-top: 4px;
}
.dialog-card {
  border-radius: 8px;
  overflow: hidden !important;
  height: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  .dialog-title {
    font-family: 'Roboto', sans-serif;
    font-size: 20px;
    color: #000000 !important;
  }
  .dialog-subtitle {
    font-size: 16px;
  }
}
.dialog-header {
  position: relative;
}
.dialog-close-icon {
  font-size: xx-large;
  position: absolute;
  top: 0px !important;
  right: 0px;
  z-index: 9999;
}
.dialog-nav-left,
.dialog-nav-right {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.2) !important;
  color: white !important;
}
.dialog-nav-left {
  left: 4px;
}
.dialog-nav-right {
  right: 4px;
}
.dialog-scroll-area {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}
.dialog-divider {
  border-width: 0.8px !important;
  border-color: #d3d3d3 !important;
  height: 100%;
}
@media (max-height: 600px) {
  .dialog-row {
    max-height: 500px;
  }
  .dialog-card {
    .dialog-title {
      font-size: 18px !important;
    }
  }
}
@media (max-height: 400px) {
  .dialog-row {
    height: 200px;
  }
}
@media (max-width: 425px) {
  .dialog-card {
    .dialog-title {
      font-size: 16px !important;
    }
    .dialog-subtitle {
      font-size: 12px !important;
    }
  }
}
.v-dialog {
  box-shadow: none !important;
}
</style>
